<template>
  <runai-section
    title="Set which pods should be deleted after workload completion or failure"
    tooltip-text="Keep pods to access their logs for debugging or remove them to free up unnecessary compute resources"
  >
    <div class="row">
      <runai-select
        :disable="sectionDisabled"
        class="col-2"
        :options="cleanPodPolicyOptions"
        :model-value="modelValue || ''"
        :policy-rules="!!policyRules ? { ...policyRules, isClosedList: true } : undefined"
        @update:model-value="$emit('update:model-value', $event?.value)"
      />
    </div>
  </runai-section>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
// Cmps
import { RunaiSection } from "@/components/common/runai-section";
import { RunaiSelect } from "@/components/common/runai-select";
// Models
import type { DistributedCleanPodPolicyRules } from "@/swagger-models/workloads-client";
import { DistributedCleanPodPolicy } from "@/swagger-models/workloads-client";

export default defineComponent({
  name: "clean-pod-policy-section",
  components: {
    RunaiSection,
    RunaiSelect,
  },
  emits: ["update:model-value"],
  props: {
    modelValue: {
      type: [String, null] as PropType<DistributedCleanPodPolicy | null>,
      required: true,
    },
    policyRules: {
      type: [Object, null] as PropType<DistributedCleanPodPolicyRules | null>,
      required: false,
    },
    sectionDisabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  data() {
    return {
      cleanPodPolicyOptions: [
        {
          label: "None",
          toolTip:
            "No pods will be deleted upon the completion or failure of the workload, and compute resources will continue to be consumed",
          value: DistributedCleanPodPolicy.None,
        },
        {
          label: "All",
          toolTip: "All pods will be deleted upon the completion or failure of the workload",
          value: DistributedCleanPodPolicy.All,
        },
        {
          label: "Running",
          toolTip:
            "Only running pods will be deleted upon the completion or failure of the workload. Completed or failed pods and their logs will remain available.",
          value: DistributedCleanPodPolicy.Running,
        },
      ],
    };
  },
});
</script>
